import React from 'react';

/**
 * useState persisté dans le localStorage.
 * Lit la valeur sauvegardée au montage, la réécrit à chaque changement.
 *
 * @param {string} key          - Clé localStorage
 * @param {*}      initialValue - Valeur par défaut si rien n'est sauvegardé
 */
export function useLocalStorage(key, initialValue) {
    const [value, setValue] = React.useState(() => {
        try {
            const saved = localStorage.getItem(key);
            return saved !== null ? JSON.parse(saved) : initialValue;
        } catch {
            return initialValue;
        }
    });

    React.useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // quota dépassé ou mode privé : on ignore silencieusement
        }
    }, [key, value]);

    return [value, setValue];
}

